import { microFrontListener } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { useRouter } from 'vue-router'
import { PAGE_ANALYTICS_INFO } from '../page-types'

/* ------- MICROFRONT - PDP ------- */

export const pdpRoutes = [
  {
    path: '/pdp/:productSlug',
    name: 'pdp',
    component: () => import('@b2ag/micro-front-pdp/app'),
    props: (route) => ({
      microFrontName: 'pdp',
      viewName: 'default',
      productSlug: route.params.productSlug,
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      private: false,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.PRODUCT_PAGE,
    },
  },
]
